import logo from "./logo.svg";
import "./App.css";
import Routing from "./Routing/Routing";
import { useSelector } from "react-redux";
import Loader from "./Components/Loader";
import Footer from "./Components/Footer";
import Header from "./Components/Header";
import { BrowserRouter, HashRouter } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SideBar from "./Components/SideBar";
import CitizenDashboard from "./Components/CitizenDashboard";
import MyProfile from "./Components/MyProfile";
import Login from "./Components/Login";

function App() {
  const isLoad = useSelector((state) => state.loader);
  const isLogin = useSelector((state) => state.auth);

  // console.log("isLogin=",isLogin)
  

  function renderLoader() {
    if (isLoad === 1) return <Loader />;
  }

  return (
    <div>
      <Header />

      <ToastContainer theme="colored" />

      {renderLoader()}

     

      {/* <div style={{ minHeight: "88vh" }} className="banner_wrapper">
        <Routing />
      </div> */}
   

      {isLogin.signIn === true?

      <div style={{ minHeight: "88vh" }} className="banner_wrapper1">
        <Routing />
      </div>

      : <div style={{ minHeight: "88vh" }} className="banner_wrapper">
      <Routing />
    </div>}

   

      <Footer />
    </div>
  );
}

export default App;
